import React, { useState, useEffect } from 'react'
import ContentWrapper from '../layouts/contentWrapper'
import Filter from '../../components/Filter';
import Loading from '../../components/Loading';
import ModalGroupEntry from '../modals/modal-group-entry';
import Grid from '../../components/Grid';
import api from '../../services/api'
import ShowMessages from '../../components/Exceptions'
import setStatistic from '../../services/apiStatistic'
import Swal from 'sweetalert2'

export default function GroupEntry() {
    const [loading, setLoading]                            = useState(false)
    const [showModal, setShowModal]                        = useState(false)
    const [isOpenFilter, setIsOpenFilter]                  = useState(false)
    const [reload, setReload]                              = useState(false)
    const [print, setPrint]                                = useState(false)
    const [excel, setExcel]                                = useState(false)
    const [showButtons, setShowButtons]                    = useState(false)
    const [editState, setEditState]                        = useState(false)
    const [gridParams, setGridParams]                      = useState({})
    const [data, setData]                                  = useState({})
    const [filters, setFilters]                            = useState([])

    const getGroupEntry= async() => {
        await api.get('/getStatusEntryGroupLink/0')
                 .then(response => {
                    setGridParams({
                                     identrygrouplink   : {text       : "#ID", mask : { name  : 'leftSlice',
                                                                                          value : '00000'},
                                                             primaryKey  : true,
                                                             visible : false},
                                     number               : {text        : "Número",
                                                             searchDefault : true},
                                     description          : {text        : "Descrição"},
                                     time                 : {text        : "Intervalo",
                                                             className : "text-center",
                                                             item        : {className : "text-center"}
                                     },
                                     quantity             : {text        : "Total de Grupos",
                                                             filter      : false,
                                     },
                                     processed            : {text        : "Processados",
                                                             filter      : false,
                                     },
                                     remaining            : {text        : "Restante",
                                                             filter      : false,
                                     },
                                     statusentrygrouplink : {text        : "Status",
                                                             filter      : false,
                                                             item        : {className : "text-center",
                                                                            switch    : {data  : response.data,
                                                                                         key   : 'idstatusentrygrouplink'}}},
                                     Options      : {text        : "Opções",
                                                     className   : "text-center",
                                                     order       : false,
                                                     filter      : false,
                                                     item        : [{type  : "Custom",
                                                                     props : {tag               : "button",
                                                                              title             : "Exclusão de links de grupo",
                                                                              className         : 'btn btn-sm btn-danger',
                                                                              visualConditional : {idstatusentrygrouplink : {operator : 'in',
                                                                                                                             values : [0,2]}},
                                                                              icon              : "fa fa-trash",
                                                                              indexcallback     : 0}},
                                                                    {type  : "Custom",
                                                                     props : {tag               : "button",
                                                                              title             : "Editar links de grupo",
                                                                              className         : 'btn btn-sm btn-warning',
                                                                              visualConditional : {idstatusentrygrouplink : {operator : 'in',
                                                                                                                            values : [0]}},
                                                                              icon              : "fa fa-edit",
                                                                              indexcallback     : 1}},
                                                                    {type  : "Custom",
                                                                     props : {tag               : "button",
                                                                              title             : "Iniciar automação de entrada",
                                                                              className         : 'btn btn-sm btn-success',
                                                                              visualConditional : {idstatusentrygrouplink : {operator : 'in',
                                                                                                                             values : [0,2]}},
                                                                              icon              : "fa fa-circle-play",
                                                                              indexcallback     : 2}},
                                                                    {type  : "Custom",
                                                                     props : {tag               : "button",
                                                                              title             : "pausar automação de entrada",
                                                                              className         : 'btn btn-sm btn-warning',
                                                                              visualConditional : {idstatusentrygrouplink : {operator : 'in',
                                                                                                                             values : [1]}},
                                                                              icon              : "fa fa-circle-pause",
                                                                              indexcallback     : 3}}]}
                                    })              
                 })
                 .catch( error => { 
                    ShowMessages(error)
                })
    }

    useEffect(() => {
        getGroupEntry()
        setStatistic('maintenance\\group-entry')
    },[])
    
    const handleCloseModal = () => {setShowModal(false)}
    const handleFilter     = () => {setIsOpenFilter(!isOpenFilter)}

    const RemoveGroupLink   = async (id) => {     
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente excluir os links de grupo?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async(result) => {
            if (result.isConfirmed) {
                await api.delete('/entrygrouplink/' + id)
                         .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                         })
                         .catch( error => {
                            ShowMessages(error)
                         })
            }
            
        }) 
    }

    const EditGroupLink = async(id) => {
        await api.get('/entrygrouplink/' + id)
                 .then(response => {
                    setData(response.data)
                    setEditState(true)
                    setShowModal(true)
                 })
                 .catch( error => {
                    ShowMessages(error)
                 })
    }

    const ActiveGroupLink = async(id) => {
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente iniciar a entrada nos grupos?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async(result) => {
            if (result.isConfirmed) {
                ShowMessages({status : 200, message : "Processo de entrada iniciado"})
                await api.post('/entrygrouplink/process/' + id,{iddepartamentstatus : 1})
                         .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                         })
                         .catch( error => {
                            ShowMessages(error)
                         })
            }
            
        }) 
    }

    const InactiveGroupLink = async(id) => {
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente pausar a entrada dos grupos?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async(result) => {
            if (result.isConfirmed) {
                await api.post('/entrygrouplink/process/' + id,{iddepartamentstatus : 2})
                         .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                         })
                         .catch( error => {
                            ShowMessages(error)
                         })
            }
            
        }) 
    }

    return (    
        <ContentWrapper>
            {loading && (
                <Loading loading={loading}/>
            )}
            <ModalGroupEntry showModal={showModal} handleCloseModal = {handleCloseModal} editState={editState} data={data} handleReload={setReload}/>
            <div className={`container-lg container-100 ${(loading ? "hidden" : "")}`}>
                <div className="content-heading">
                    <div  className="box-maintance-buttons">
                        <div>
                            <button className="btn btn-success" title="Insere um novo registro" onClick={e => {setEditState(false) 
                                                                                                                                                 setShowModal(true)}}><i className="fa fa-plus"></i></button>
                            <button className="btn btn-primary" title="Atualizar Dados" style={{marginLeft:"3px"}} onClick={e => setReload(true)}><i className="fa fa-redo"></i></button>
                            {showButtons ? 
                                <>
                                    <button className="btn btn-dark" title="Impressão" onClick={e => setPrint(true)} style={{marginLeft:"3px"}}><i className="fa fa-print"></i></button>
                                    <button className="btn btn-info" title="Exportar para excel" onClick={e => setExcel(true)} style={{marginLeft:"3px"}}><i className="fa fa-file-excel">    </i></button>
                                    <button className="btn btn-secondary" title="Filtros Avançados" style={{marginLeft:"3px"}} onClick={e => handleFilter()}><i className="fa fa-search-plus"></i></button>
                                </>
                            : "" }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`content-box-cart ${(loading ? "hidden" : "")}`}>
                <Filter isOpenFilter={isOpenFilter} filters={gridParams} callback={setFilters} callBackOpenFilter={handleFilter}/>
                <Grid url                 = '/entrygrouplink' 
                      headers             = {gridParams} 
                      loading             = {setLoading} 
                      reload              = {reload}
                      print               = {print}
                      excel               = {excel}
                      filters             = {filters}
                      callbackShowButtons = {setShowButtons}
                      callbackPrint       = {setPrint}
                      callbackReload      = {setReload}
                      callbackExcel       = {setExcel}
                      callbackCellClick   = {EditGroupLink}
                      filename            = "Link de Grupos"
                      callbackButtons     = {[RemoveGroupLink, 
                                              EditGroupLink,
                                              ActiveGroupLink,
                                              InactiveGroupLink]}
                      />  
               
            </div>                    
        </ContentWrapper>
    )
}